export default class UserService {
  getAuthenticatedUser = () => {
    return typeof localStorage !== 'undefined'
      ? JSON.parse(localStorage.getItem('authenticatedUser')) || null
      : null;
  };
}
